import React,{ useState, useEffect } from 'react'
import firebase from "../../helpers/firebase";
import {useHistory} from "react-router-dom";
import {localStore} from "../../helpers/localStorage";
import Alert from "@material-ui/lab/Alert";

function StartExcercise() {
    const db = firebase.firestore();
    const sessionId = localStore.getSession();
    const history = useHistory();
    const [testEnded, setTestEnded] = useState(false);

    useEffect(() => {
      setTestEnded(false);
        try {
          if (sessionId) {
            watchResponses();
          }
        } catch (err) {
          console.log(err);
        }
         // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);

      const watchResponses = () => {
        db.collection("sessions")
          .doc(sessionId)
          .onSnapshot((doc) => {
            if(doc.exists){
                let data  = doc.data();
                 if(data.status === "TEST_STARTED"){
                    history.push(`/student/write_answer?status=TEST_STARTED`);
                 }
                 if(data.status === "TEST_END"){
                  setTestEnded(true);
               }
            }
          });
      };


    return (
        <>
        {testEnded && <Alert className="error-top" severity="warning">Test ended by the instructor</Alert>}
        <h2>awaiting an exercise</h2>
        </>
    )
}

export default StartExcercise
